import axios from 'axios';
import { FilterModel, PreOrderData, PreOrderObservationRequest, PreOrderRequest, ProcessResult } from "../Interfaces"
import { getPreOrderEndpoint, getPreOrderObservationEndpoint } from '../Endpoints';
import { getDateInYYYYMMDDWithoutTimeFormat, getDefaultHeaders } from '../Utils';

export const getPreOrders = async (token: string, managementId: string, companyId: number, page?: number, filtering?:FilterModel[]): Promise<{data: PreOrderData[], count: number}> => {
    try{
        const {data, status} = await axios.get(`${getPreOrderEndpoint}/company/${companyId}`, getDefaultHeaders(token, managementId, page, filtering, "Filter"));
        if (status === 200 && data.Ok){
            const result: PreOrderData[] = data.Data;
            return {data: result, count: data.Count};
        }

        return {data: [], count: 0};
    } catch {
        return {data: [], count: 0};
    }
}

export const getPreOrder = async (id: number, token: string, managementId: string): Promise<PreOrderData|undefined> => {
    try{
        const {data, status} = await axios.get(`${getPreOrderEndpoint}/${id}`, getDefaultHeaders(token, managementId));
        if (status === 200 && data.Ok){
            const result: PreOrderData = data.Data;
            return result;
        }

        return undefined;
    }catch{
        return undefined;
    }
}

export const addObservation = async (preOrderId: number, obs: string, date: string, token: string, managementId: string) : Promise<ProcessResult> => {
    try{
        const obsRequest: PreOrderObservationRequest = {
            Observation: obs,
            Date: date
        }
    
        const {data, status} = await axios.put(getPreOrderObservationEndpoint(preOrderId), obsRequest, getDefaultHeaders(token, managementId));
        if (status === 200 && data.Ok){
            return {Ok: true};
        }

        return {Ok: false};
    }
    catch (error: any){
        console.error("Error on addObservation >>> ", JSON.stringify(error));
        return {Ok: false, data: error.message};
    }
}

export const createPreOrder = async (preOrder: PreOrderData, token: string, managementId: string, companyId: number, userName: string): Promise<ProcessResult> => {
    try{
        const preOrderRequest: PreOrderRequest = {
            ClientName: preOrder.ClientName,
            ClientIdentificationType: preOrder?.ClientIdentificationType ?? '',
            ClientIdentification: preOrder?.ClientIdentification,
            ClientPhoneNumber: preOrder?.ClientPhoneNumber,
            StateId: Number.parseInt(preOrder?.State?.Id ?? '0'),
            CityId: Number.parseInt(preOrder?.City?.Id ?? '0'),
            ClientAddress: preOrder.ClientAddress ?? '',
            ClientEmail: preOrder.ClientEmail ?? '',
            ProductBrandId: Number.parseInt(preOrder.ProductBrand?.Id ?? '0'),
            ProductTypeId: Number.parseInt(preOrder.ProductType?.Id ?? '0'),
            ProductModel: preOrder.ProductModel ?? '',
            ProductSerial: preOrder.ProductSerial ?? '',
            Observation: `${preOrder.ProductLocation} > ${preOrder.Observation}`,
            CreatedBy: userName,
            CompanyId: companyId,
            ManagementId: managementId,
            BillNumber: preOrder.BillNumber,
            BillDate: preOrder.BillDate ? getDateInYYYYMMDDWithoutTimeFormat(new Date(preOrder.BillDate!)) : undefined,
        }
    
        const {data, status} = await axios.post(getPreOrderEndpoint, preOrderRequest, getDefaultHeaders(token, managementId));
        if (status === 200 && data.Ok){
            return {Ok: true, data: data.Data};
        }

        return {Ok: false};
    }
    catch (error: any){
        console.error("Error on createPreOrder >>> ", JSON.stringify(error));
        return {Ok: false, data: error.message};
    }
}